import { SiteData } from '../client-data/site-data';
import { loadedData } from './metrics-loader';
import { GTM } from './google-tag-manager';

class Metrics {
  pageLeave = () => (dispatch) => {
    dispatch(this.metricsData.pageLeave());
  };

  pageLoad = () => (dispatch) => {
    // initialise the metrics on a new page
    dispatch(this.metricsData.pageLoad());
  };

  init = () => (dispatch) => {
    if (this.metricsData) {
      this.metricsData.destroy();
      this.metricsData = null;
    }

    this.metricsData = new SiteData();
    dispatch(this.metricsData.init({ ...loadedData }));
  };

  logEvent = (eventName, interactionData, immediate = false, options = {}) => (
    dispatch
  ) => {
    GTM.pushEvent(eventName, interactionData);

    const sentData = dispatch(
      this.metricsData.logEvent(eventName, interactionData, immediate, options)
    );
    // console.log('EVENT!', eventName, sentData);
    return sentData;
  };

  identify(user, traits) {
    this.metricsData.identify(user, traits);
  }
}

export const metrics = new Metrics(loadedData);
